// extracted by mini-css-extract-plugin
export var copy = "copy-module--copy--3SBfs";
export var copy_year = "copy-module--copy_year--345Rk";
export var copy_dev = "copy-module--copy_dev--2U8-P";